<template>
  <div id="app">
    <component
      :is="layout"
      class="page-wrapper"
    >
      <router-view :key="$route.path" />
    </component>
  </div>
</template>

<script>
import BlankLayout from '@/common/layouts/BlankLayout';
import HomeLayout from '@/common/layouts/HomeLayout';
import ErrorLayout from '@/common/layouts/ErrorLayout';
import UnauthorisedErrorLayout from '@/common/layouts/UnauthorisedErrorLayout';
import AppError from '@/utils/AppError';
import AppWindow from '@/utils/AppWindow';
import AppSync from '@/utils/AppSync';
// import Browser from '@/utils/Browser';

export default {
  components: {
    BlankLayout,
    HomeLayout,
    ErrorLayout,
    UnauthorisedErrorLayout,
  },
  mixins: [
    AppError,
    AppWindow,
    AppSync,
  ],
  computed: {
    layout() {
      return (this.$route.meta && this.$route.meta.layout) || 'BlankLayout';
    },
  },
  beforeCreate() {
    // if (Browser.isChrome === false) {  // TODO commented for katalon testing
    //   this.$router.push('/chrome-only');
    // }
  },
  created() {
    window.$app = this;
  },
  methods: {
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables.scss';
@import '~@/styles/global.scss';

#app {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
